import { createTypes } from "@/store/utils";

export const FETCH_ACCOUNT_LETTERS_HISTORY = createTypes(
  "FETCH_ACCOUNT_LETTERS_HISTORY"
);
